// frontend/src/authContext.js
// Shared auth context so the AppShell can read the current user + logout handler
// without threading props through every route.
import { createContext } from 'react';

export const AuthContext = createContext({ user: null, onLogout: () => {} });
